/** 评估结论与覆盖率数字的展示规则：原始字段名与界面中文标签的映射集中在此 */

/** 结论四态 —— 与报告 conclusion.json 的 state 一一对应 */
export const CONCLUSION_META = {
  达标: { label: '达标', tag: 'success' },
  部分达标: { label: '部分达标', tag: 'warning' },
  不达标: { label: '不达标', tag: 'danger' },
  无法判定: { label: '无法判定', tag: 'info' },
};

/** 结论态 ⇒ 标签文案与颜色；认不出的原样显示 */
export function conclusionMeta(state) {
  return CONCLUSION_META[state] || { label: state || '未记录', tag: 'info' };
}

/** 推理参数（契约字段）⇒ 中文标签 */
export const CONTRACT_LABELS = {
  imgsz: '输入尺寸',
  conf: '置信度阈值',
  iou: 'IoU 阈值',
  mask_threshold: '掩码阈值',
  max_det: '最大检出数',
  engine: '推理引擎',
  precision: '精度模式',
  batch: '批大小',
  preprocess: '预处理',
  ultralytics: 'ultralytics 版本',
  torch: 'torch 版本',
};

/** 划分 ⇒ 中文 */
export const SPLIT_LABELS = { train: '训练', val: '验证', test: '测试' };

/** 划分值 ⇒ 中文标签（认不出原样显示） */
export function splitLabel(split) {
  return SPLIT_LABELS[split] || dash(split);
}

/** ultralytics val 指标 ⇒ 中文标签（(B)＝框，(M)＝掩码） */
export const METRIC_LABELS = {
  'metrics/precision(B)': '精确率（框）',
  'metrics/recall(B)': '召回率（框）',
  'metrics/mAP50(B)': 'mAP50（框）',
  'metrics/mAP50-95(B)': 'mAP50-95（框）',
  'metrics/precision(M)': '精确率（掩码）',
  'metrics/recall(M)': '召回率（掩码）',
  'metrics/mAP50(M)': 'mAP50（掩码）',
  'metrics/mAP50-95(M)': 'mAP50-95（掩码）',
  fitness: '综合得分',
};

/** 指标原字段名 ⇒ 中文标签（映射表没有的原样显示） */
export function metricLabel(key) {
  return METRIC_LABELS[key] || key;
}

/** 覆盖率 ⇒ 百分比文本；null（未评估）写破折号而不是 0% */
export function rateText(rate) {
  return typeof rate === 'number' ? `${(rate * 100).toFixed(1)}%` : '—';
}

/** 覆盖率条目的颜色：达标绿、低于阈值红、没有真值灰 */
export const RATE_COLORS = {
  ok: '#67c23a',
  below: '#f56c6c',
  none: '#c0c4cc',
};

/** 覆盖率 ⇒ 条形颜色（达标绿、低于阈值红、没有真值灰） */
export function rateColor(rate, threshold) {
  if (typeof rate !== 'number') return RATE_COLORS.none;
  return rate >= threshold ? RATE_COLORS.ok : RATE_COLORS.below;
}

/** 0 与 false 都是有效值，只有 null / undefined / 空串按缺省显示 */
export function dash(value) {
  return value === null || value === undefined || value === '' ? '—' : value;
}

/** 覆盖率图上的阈值参考线（横轴为 0~1 的覆盖率） */
export function coverageMarkLine(lines) {
  return {
    silent: true,
    symbol: 'none',
    lineStyle: { color: '#e6a23c', type: 'dashed' },
    // 标签位置只认 start / end：其他位置 ECharts 会把标签按线方向旋转成竖排小字
    label: { color: '#e6a23c', fontSize: 11, position: 'start' },
    data: lines.map(line => ({
      xAxis: line.threshold,
      label: { formatter: line.label },
    })),
  };
}
